import * as Yup from "yup";
import { Request } from "../../hooks/Request";
import { Circle } from "../../components/Animation";
import { toast } from "react-toastify";
import { requestAuth } from "../../components/services/RequestService";
import View from "../../components/GeneratePdf/View";
import Text from "../../components/GeneratePdf/Text";
import { useAuth } from "../../contexts/AuthContext";
import { useDialog } from "../../contexts/DialogContext";
import { Button } from "../../components/Buttons";
import FormDefault from "../../components/Forms/FormDefault";
import { Page, Document, PDFViewer, Image, pdf } from "@react-pdf/renderer";
import * as dayjs from "dayjs";
import { toDecimalString } from "../../utils/validate";
dayjs.locale("es");

const RenderSettlement = (props) => {
  const { openDialog } = useDialog();

  const { data, loading } = Request({
    urlApi: "/dropdown/user/accountNumbers",
  });

  function handleProform(values) {
    openDialog(
      <LiquidaciónProform {...props} accountNumber={values.account} />
    );
  }

  function handleAccount() {
    const list = data.map((item) =>
      item.accountNumber
        ? {
          label: `${item.accountNumber} - ${item.name} ${item.fatherLastName}`,
          value: item.accountNumber,
        }
        : null
    );
    return list.filter((n) => n);
  }

  if (!loading) {
    return <Circle />;
  }
  return (
    <FormDefault
      tittle="Elaborador por/ Nro de Cuenta Bancaria a Depositar"
      fields={[
        {
          label: "Atención",
          name: "account",
          typeInput: "select",
          options: handleAccount(),
          //   [
          //   {
          //     label: "Original",
          //     value: "Original",
          //   },
          //   {
          //     label: "Copia",
          //     value: "Copia",
          //   },
          //   {
          //     label: "Fotocopia simple",
          //     value: "Fotocopia simple",
          //   },
          //   {
          //     label: "Fotocopia legalizada",
          //     value: "Fotocopia legalizada",
          //   },
          // ],
          // typeInput: "selectNewOption",
          // urlApi: "/dropdown/user/accountNumbers",
          // value: "name",
          // labelOption: "name",
        },
      ]}
      initialValues={{
        account: "",
      }}
      validationSchema={Yup.object().shape({
        // atn: Yup.string().required("Campo requerido"),
      })}
      onSubmit={handleProform}
      buttonName="Registrar"
    />
  );
};

const LiquidaciónProform = (props) => {
  const { procedure, accountNumber, isQuotation } = props;
  const { user } = useAuth();
  // const { data, loading } = Request({
  //   urlApi: `/tradecruz/${procedure.id || procedure.procedureId}/${isQuotation ? 'proform' : 'payroll'}`,
  // });

  const { data: dataProc, loading: loadingDataProc } = Request({
    urlApi: `/procedure/${procedure.id || procedure.procedureId}/dataValues`,
    params: {
      fieldnames: [
        "nroCotizacion",
        "codigoDeInterno",
        "doc_embarque",
        "int_agencia",
        "e3NúmeroDeFactura",
        "f3TotalNúmeroDeBultos",
        "f5TotalPesoNeto",
        "e1DatosDelProveedor",
        "descripciónDeLaMercancía",
        "f6TotalValorFob",
        "flete1y2",
        "f8TotalCostoDelSeguro",
        "f9GastosDeCarga,Descarga,ManipuleoYOtrosGastos",
        "e23ValorCifAduanaTotal(Usd)",
        "tipoDeCambio",
        "f10TotalValorCifAduana",
        "a4AduanaDeDespacho",
        "a7ModalidadDeDespacho",
        "f2TotalNúmeroDeItems",
        "a1NúmeroDeDeclaración",
        "a2FechaDeAceptación",
        "a-TributosYOtrosConceptosAduaneros",
        "b-OtrosGastosDeImportacion/Exportacion",
        "c-GastosDeOperaciones",
        "d-HonorariosProfesionales",
        "e-OtrosGastos",
        "tributosUOtrasGastosPagadosPorElImportador",
        "totalAnticipos",
        "observacionDeCotizacion"
      ]
    }
  });

  if (!loadingDataProc) {
    return <div className="p-2"><Circle /></div>;
  }

  async function handleOnClick() {
    await pdf(MyDoc)
      .toBlob()
      .then((r) => {
        var file = new File([r], `Planilla-${dayjs().format("DD-MM-YYYY")}`);
        uploadFile(file);
      });
  }

  async function uploadFile(file) {
    let formData = new FormData();
    formData.append("Name", `Planilla-${dayjs().format("DD-MM-YYYY")}`);
    formData.append("File", file);
    formData.append(
      "originalName",
      `Planilla-${dayjs().format("DD-MM-YYYY")}.pdf`
    );
    formData.append("Status", "verified");
    formData.append("ProcedureId", procedure.id || procedure.procedureId);
    await requestAuth("post", "/files", formData)
      .then((res) => {
        handleRegister({
          url: res.data.url,
          name: `Planilla-${dayjs().format("DD-MM-YYYY")}`,
        });
      })
      .catch(() => {
        toast.error("Se produjo un error al subir el archivo");
      });
  }

  async function handleRegister(values) {
    await requestAuth(
      "post",
      `/fileState/procedure/${procedure.id || procedure.procedureId}/field/725`,
      values
    )
      .then(() => {
        toast.success("Registro exitoso");
      })
      .catch(() => {
        toast.error("Se produjo un error al guardar");
      });
  }

  function toNumber(value) {
    const n = parseFloat(value);
    return isNaN(n) ? 0 : n;
  }

  function sumSubData(dataProc, key) {
    const arr = dataProc?.[key] ?? [];
    console.log(arr)
    if (isQuotation)
      return arr.reduce((acc, item) => acc + toNumber(item?.description), 0);
    else
      return arr.reduce((acc, item) => acc + toNumber(item?.description2), 0);
  }

  function calculateTotals() {
    const a = sumSubData(dataProc, "a-TributosYOtrosConceptosAduanerosSubDatas");
    const b = sumSubData(dataProc, "b-OtrosGastosDeImportacion/ExportacionSubDatas");
    const c = sumSubData(dataProc, "c-GastosDeOperacionesSubDatas");
    const d = sumSubData(dataProc, "d-HonorariosProfesionalesSubDatas");
    const e = sumSubData(dataProc, "e-OtrosGastosSubDatas");

    const totalBob = a + b + c + d + e;
    const tc = dataProc.tipoDeCambio ?? 0;
    const totalSus = tc === 0 ? 0 : totalBob / tc;
    console.log("a")
    console.log(a)
    console.log("b")
    console.log(b)
    console.log("c")
    console.log(c)
    console.log("d")
    console.log(d)
    console.log("e")
    console.log(e)
    console.log("totalBob")
    console.log(totalBob)
    console.log("totalSus")
    console.log(totalSus)

    // calcular saldo resta de totalBob - (tributosUOtrasGastosPagadosPorElImportador + totalAnticipos)

    const saldo = totalBob - (toNumber(dataProc.tributosUOtrasGastosPagadosPorElImportador) + toNumber(dataProc.totalAnticipos));
    console.log("saldo")
    console.log(saldo)

    return {
      a,
      b,
      c,
      d,
      e,
      totalBob,
      totalSus,
      saldo
    };
  }

  const MyDoc = (
    <Document>
      <Page size="A4" style={{ padding: "20px" }}>
        <Image
          src={'https://res.cloudinary.com/dnwvlkw3r/image/upload/v1763761565/TRAZO/LOGOS/logoazul1_rsxtlo.png'} // o la URL del logo
          style={{
            position: "absolute",
            top: "25%",
            left: "25%",
            width: "400px", // ajusta tamaño
            height: "400px",
            opacity: 0.1, // opacidad baja para que sea marca de agua
            transform: "translate(-50%, -50%)", // centra la imagen
            zIndex: 0,
          }}
        />
        <View flexDirection="column" borderContent>
          <View padding="4px" style={{ backgroundColor: "#213a8f" }}></View>
          <View flexDirection="column">
            <View
              justifyContent="space-between"
              alignItems="center"
              padding="4px 4px"
            >
              <View width="25%">
                <Image src={'https://res.cloudinary.com/dnwvlkw3r/image/upload/v1763761565/TRAZO/LOGOS/logoazul1_rsxtlo.png'} style={{ height: "50px" }} />
              </View>
              <View
                width="60%"
                flexDirection="column"
                alignItems="flex-end"
                justifyContent="flex-end"
              >
                <Text
                  color="#213a8f"
                  padding="0px 3px"
                  textAlign="end"
                  fontSize="16px"
                  bold
                >
                  {isQuotation ? 'COTIZACIÓN' : 'PLANILLA DE COBRANZA'}
                  {/* PROFORMA */}
                </Text>
                <Text
                  color="#213a8f"
                  padding="0px 3px"
                  fontSize="18px"
                  bold
                  textAlign="end"
                >
                  {isQuotation ? dataProc.nroCotizacion : dataProc.codigoDeInterno}
                </Text>
                <Text fontSize="10px" padding="0px 3px" textAlign="end">
                  Oruro {dayjs().format("DD")} de {dayjs().format("MMMM")}{" "}
                  del {dayjs().format("YYYY")}
                </Text>
              </View>
            </View>
            <View
              border={{ top: true }}
              // style={{ marginTop: "5px" }}
              padding="3px 0px 0px 0px"
            >
              <View width="65%" flexDirection="column">
                <Text padding="2px 3px">
                  <Text padding="2px 3px" bold>
                    SEÑOR(ES):{" "}
                  </Text>
                  <Text padding="2px 3px">{dataProc.company.razonSocial}</Text>
                </Text>
              </View>
              <View width="35%">
                <Text padding="2px 3px">
                  <Text padding="2px 3px" bold>
                    NIT:{" "}
                  </Text>
                  <Text padding="2px 3px">{dataProc.company.nit}</Text>
                </Text>
              </View>
            </View>
            <View
            // style={{ marginTop: "5px" }}
            >
              <View width="65%" flexDirection="column">
                <Text padding="2px 3px">
                  <Text padding="2px 3px" bold>
                    Doc. Embarque:{" "}
                  </Text>
                  <Text padding="2px 3px">{dataProc.doc_embarque}</Text>
                </Text>
              </View>
              <View width="35%">
                <Text padding="2px 3px">
                  <Text padding="2px 3px" bold>
                    Int. Agencia:{" "}
                  </Text>
                  <Text padding="2px 3px">{dataProc.int_agencia}</Text>
                </Text>
              </View>
            </View>

            <View
            // style={{ marginTop: "5px" }}
            >
              <View width="50%" flexDirection="column">
                <Text padding="2px 3px">
                  <Text padding="2px 3px" bold>
                    Facturas(s):{" "}
                  </Text>
                  <Text padding="2px 3px">{dataProc["e3NúmeroDeFactura"]}</Text>
                </Text>
              </View>
              <View width="25%">
                <Text padding="2px 3px">
                  <Text padding="2px 3px" bold>
                    Bultos:{" "}
                  </Text>
                  <Text padding="2px 3px">{dataProc["f3TotalNúmeroDeBultos"] ?? 0}</Text>
                </Text>
              </View>
              <View width="25%">
                <Text padding="2px 3px">
                  <Text padding="2px 3px" bold>
                    Peso:{" "}
                  </Text>
                  <Text padding="2px 3px">{toDecimalString(dataProc["f5TotalPesoNeto"])}</Text>
                </Text>
              </View>
            </View>
            <View
              flexDirection="column"
              // style={{ marginTop: "5px" }}
              padding="0px 0px 3px 0px"
            >
              <View>
                <View width="50%">
                  <Text padding="2px 3px">
                    <Text padding="2px 3px" bold>
                      Proveedor/Emisor:{" "}
                    </Text>
                    <Text padding="2px 3px">{dataProc.e1DatosDelProveedor}</Text>
                  </Text>
                </View>
              </View>
              <Text padding="2px 3px">
                <Text padding="2px 3px" bold>
                  Mercadería:{" "}
                </Text>
                <Text padding="2px 3px">{dataProc["descripciónDeLaMercancía"]}</Text>
              </Text>
            </View>
            <View border={{ top: true, bottom: true }} padding="3px 0px 3px 0px">
              <View width="13%" flexDirection="column">
                <Text padding="2px 3px" bold>
                  Valor FOB
                </Text>
                <Text padding="2px 3px" bold>
                  Fletes I,II
                </Text>
                <Text padding="2px 3px" bold>
                  Seguro
                </Text>
                <Text padding="2px 3px" bold>
                  Otros Gastos
                </Text>
                <Text padding="2px 3px" bold>
                  Valor CIF
                </Text>
                <Text padding="2px 3px" bold>
                  T.c.
                </Text>
                <Text padding="2px 3px" bold>
                  Valor CIF
                </Text>
              </View>
              <View width="5%" flexDirection="column">
                <Text padding="2px 3px">$us.</Text>
                <Text padding="2px 3px">$us.</Text>
                <Text padding="2px 3px">$us.</Text>
                <Text padding="2px 3px">$us.</Text>
                <Text padding="2px 3px">$us.</Text>
                <Text padding="2px 3px">{toDecimalString(dataProc.tipoDeCambio)}</Text>
                <Text padding="2px 3px">Bs.</Text>
              </View>
              <View
                width="12%"
                flexDirection="column"
                justifyContent="flex-end"
                alignItems="flex-end"
              >
                <Text padding="2px 3px">{toDecimalString(dataProc["f6TotalValorFob"])}</Text>
                <Text padding="2px 3px">{toDecimalString(dataProc["flete1y2"])}</Text>
                <Text padding="2px 3px">{toDecimalString(dataProc["f8TotalCostoDelSeguro"])}</Text>
                <Text padding="2px 3px">{toDecimalString(dataProc["f9GastosDeCarga,Descarga,ManipuleoYOtrosGastos"])}</Text>
                <Text padding="2px 3px">{toDecimalString(dataProc["e23ValorCifAduanaTotal(Usd)"])}</Text>
                <Text padding="2px 3px"> </Text>
                <Text padding="2px 3px">{toDecimalString(dataProc["f10TotalValorCifAduana"])}</Text>
              </View>
              <View
                style={{ marginLeft: "5%" }}
                width="50%"
                flexDirection="column"
              >
                <Text padding="2px 3px">
                  <Text padding="2px 3px" bold>
                    Aduana:{" "}
                  </Text>
                  <Text padding="2px 3px">{dataProc["a4AduanaDeDespacho"]}</Text>
                </Text>
                <Text padding="2px 3px">
                  <Text padding="2px 3px" bold>
                    Modalidad:{" "}
                  </Text>
                  <Text padding="2px 3px">{dataProc["asignarRégimenDeImportación"]}</Text>
                </Text>
                <Text padding="2px 3px">
                  <Text padding="2px 3px" bold>
                    Items:{" "}
                  </Text>
                  <Text padding="2px 3px">{dataProc["f2TotalNúmeroDeItems"]}</Text>
                </Text>
                <Text padding="2px 3px">
                  <Text padding="2px 3px" bold>
                    Tipo:{" "}
                  </Text>
                  <Text padding="2px 3px">{dataProc.procedureTypeId === 1 ? "DIM/DUI" : "DEX"}</Text>
                </Text>
                <Text padding="2px 3px">
                  <Text padding="2px 3px" bold>
                    DIM/DEX:{" "}
                  </Text>
                  <Text padding="2px 3px">{dataProc["a1NúmeroDeDeclaración"]}</Text>
                </Text>
                <Text padding="2px 3px">
                  <Text padding="2px 3px" bold>
                    Nro. de factura:{" "}
                  </Text>
                  <Text padding="2px 3px">{dataProc["factura"]}</Text>
                </Text>
                <Text padding="2px 3px">
                  <Text padding="2px 3px" bold>
                    Fecha de Validación:{" "}
                  </Text>
                  <Text padding="2px 3px">{dataProc["a2FechaDeAceptación"]}</Text>
                </Text>
              </View>
            </View>
            <View style={{ backgroundColor: "#dddddd" }}>
              <Text bold>A - Tributos y otros Conceptos Aduaneros</Text>
            </View>
            {dataProc["a-TributosYOtrosConceptosAduanerosSubDatas"]?.map(
              (element, idx) =>
                element.description != null &&
                element.description !== "0" && (
                  <View key={idx} justifyContent="space-between">
                    <View width="50%">
                      <Text padding="2px 3px">
                        {element.label} {element.recibo ? "*" : ""}
                      </Text>
                    </View>
                    <View width="50%" justifyContent="flex-end">
                      <Text padding="2px 3px" textAlign="end">
                        {toDecimalString(element.description)}
                      </Text>
                    </View>
                  </View>
                )
            )}
            <View justifyContent="flex-end">
              <View width="10%">
                <Text padding="2px 3px" bold>
                  Sub Total:
                </Text>
              </View>
              <View width="20%" justifyContent="flex-end">
                <Text padding="2px 3px" bold textAlign="end">
                  {toDecimalString(calculateTotals().a)}
                </Text>
              </View>
            </View>
            <View style={{ backgroundColor: "#dddddd" }}>
              <Text padding="2px 3px" bold>
                B - Otros Gastos de Importacion/Exportacion
              </Text>
            </View>
            {dataProc["b-OtrosGastosDeImportacion/ExportacionSubDatas"]?.map(
              (element) =>
                element.description != null &&
                element.description !== "0" && (
                  <View justifyContent="space-between">
                    <View width="50%">
                      <Text padding="2px 3px">
                        {element.label} {element.recibo ? "*" : ""}
                      </Text>
                    </View>
                    <View width="50%" justifyContent="flex-end">
                      <Text padding="2px 3px" textAlign="end">
                        {toDecimalString(element.description)}
                      </Text>
                    </View>
                  </View>
                )
            )}
            <View justifyContent="flex-end">
              <View width="10%">
                <Text padding="2px 3px" bold>
                  Sub Total:
                </Text>
              </View>
              <View width="20%" justifyContent="flex-end">
                <Text padding="2px 3px" bold textAlign="end">
                  {toDecimalString(calculateTotals().b)}
                </Text>
              </View>
            </View>
            <View style={{ backgroundColor: "#dddddd" }}>
              <Text padding="2px 3px" bold>
                C - Gastos de Operaciones
              </Text>
            </View>
            {dataProc["c-GastosDeOperacionesSubDatas"]?.map(
              (element) =>
                element.description != null &&
                element.description !== "0" && (
                  <View justifyContent="space-between">
                    <View width="50%">
                      <Text padding="2px 3px">
                        {element.label} {element.recibo ? "*" : ""}
                      </Text>
                    </View>
                    <View width="50%" justifyContent="flex-end">
                      <Text padding="2px 3px" textAlign="end">
                        {toDecimalString(element.description)}
                      </Text>
                    </View>
                  </View>
                )
            )}
            <View justifyContent="flex-end">
              <View width="10%">
                <Text padding="2px 3px" bold>
                  Sub Total:
                </Text>
              </View>
              <View width="20%" justifyContent="flex-end">
                <Text padding="2px 3px" bold textAlign="end">
                  {toDecimalString(calculateTotals().c)}
                </Text>
              </View>
            </View>
            <View style={{ backgroundColor: "#dddddd" }}>
              <Text padding="2px 3px" bold>
                D - Honorarios Profesionales
              </Text>
            </View>
            {dataProc["d-HonorariosProfesionalesSubDatas"]?.map(
              (element) =>
                element.description != null &&
                element.description !== "0" && (
                  <View justifyContent="space-between">
                    <View width="50%">
                      <Text padding="2px 3px">
                        {element.label} {element.recibo ? "*" : ""}
                      </Text>
                    </View>
                    <View width="50%" justifyContent="flex-end">
                      <Text padding="2px 3px" textAlign="end">
                        {toDecimalString(element.description)}
                      </Text>
                    </View>
                  </View>
                )
            )}
            <View justifyContent="flex-end">
              <View width="10%">
                <Text padding="2px 3px" bold>
                  Sub Total:
                </Text>
              </View>
              <View width="20%" justifyContent="flex-end">
                <Text padding="2px 3px" bold textAlign="end">
                  {toDecimalString(calculateTotals().d)}
                </Text>
              </View>
            </View>
            {/* TODO: posible map null puede generar una excepción*/}
            <View style={{ backgroundColor: "#dddddd" }}>
              <Text padding="2px 3px" bold>
                E - Otros gastos
              </Text>
            </View>
            {dataProc["e-OtrosGastosSubDatas"]?.map(
              (element) =>
                element.description != null &&
                element.description !== "0" && (
                  <View justifyContent="space-between">
                    <View width="50%">
                      <Text padding="2px 3px">
                        {element.label} {element.recibo ? "*" : ""}
                      </Text>
                    </View>
                    <View width="50%" justifyContent="flex-end">
                      <Text padding="2px 3px" textAlign="end">
                        {toDecimalString(element.description)}
                      </Text>
                    </View>
                  </View>
                )
            )}
            <View justifyContent="flex-end">
              <View width="10%">
                <Text padding="2px 3px" bold>
                  Sub Total:
                </Text>
              </View>
              <View width="20%" justifyContent="flex-end">
                <Text padding="2px 3px" bold textAlign="end">
                  {toDecimalString(calculateTotals().e)}
                </Text>
              </View>
            </View>
            <View
              flexDirection="column"
              padding="5px"
              border={{ top: true, bottom: true }}
              style={{ marginTop: "5px" }}
            >
              <View justifyContent="flex-end">
                <View width="19%" justifyContent="flex-end">
                  <Text padding="3px 3px" bold>
                    Total {isQuotation ? 'Proforma' : 'Planilla'} $us. {dataProc.tipoDeCambio}
                  </Text>
                </View>
                <View borderContent width="20%" justifyContent="flex-end">
                  <Text padding="3px 3px" bold textAlign="end">
                    {toDecimalString(calculateTotals().totalSus)}
                  </Text>
                </View>
              </View>
              <View justifyContent="flex-end">
                <View width="16%" justifyContent="flex-end">
                  <Text padding="3px 3px" bold>
                    Total {isQuotation ? 'Proforma' : 'Planilla'} (Bs.)
                  </Text>
                </View>
                <View
                  border={{ right: true, left: true, bottom: true }}
                  width="20%"
                  justifyContent="flex-end"
                >
                  <Text padding="3px 3px" bold textAlign="end">
                    {toDecimalString(calculateTotals().totalBob)}
                  </Text>
                </View>
              </View>
              <View justifyContent="flex-end">
                <View width="25%" justifyContent="flex-end">
                  <Text padding="3px 3px" bold>
                    Gastos pagados por el importador
                  </Text>
                </View>
                <View
                  border={{ right: true, left: true, bottom: true }}
                  width="20%"
                  justifyContent="flex-end"
                >
                  <Text padding="3px 3px" bold textAlign="end">
                    {toDecimalString(dataProc["tributosUOtrasGastosPagadosPorElImportador"])}
                  </Text>
                </View>
              </View>
              <View justifyContent="flex-end">
                <View width="12%" justifyContent="flex-end">
                  <Text padding="3px 3px" bold>
                    Total Anticipos
                  </Text>
                </View>
                <View
                  border={{ right: true, left: true, bottom: true }}
                  width="20%"
                  justifyContent="flex-end"
                >
                  <Text padding="3px 3px" bold textAlign="end">
                    {toDecimalString(dataProc.totalAnticipos)}
                  </Text>
                </View>
              </View>

              <View justifyContent="flex-end">
                {parseFloat(calculateTotals().saldo ?? 0) < 0 ? (
                  <View width="19%" justifyContent="flex-end">
                    <Text padding="3px 3px" bold>
                      Saldo a favor Cliente (Bs.)
                    </Text>
                  </View>
                ) : parseFloat(calculateTotals().saldo ?? 0) > 0 ? (
                  <View width="20%">
                    <Text padding="3px 3px" bold>
                      Saldo a favor Agencia (Bs.)
                    </Text>
                  </View>
                ) : (
                  <View width="9%">
                    <Text padding="3px 3px" bold>
                      Saldo (Bs.)
                    </Text>
                  </View>
                )}

                <View
                  border={{ right: true, left: true, bottom: true }}
                  width="20%"
                  justifyContent="flex-end"
                >
                  <Text padding="3px 3px" bold textAlign="end">
                    {toDecimalString(calculateTotals().saldo > 0 ? calculateTotals().saldo : calculateTotals().saldo * -1)}
                  </Text>
                </View>
              </View>
            </View>
            {isQuotation && dataProc.observacionDeCotizacion ? (
              <Text padding="5px 3px 3px 3px" color="#004080" fontSize="7px" bold>
                OBSERVACIONES: {dataProc.observacionDeCotizacion}
              </Text>
            ) : null}
            <View>
              <View width="50%" flexDirection="column">
                <Text padding="2px 3px" color="#004080" bold>
                  BANCO UNION S.A. (Cta. Corriente)
                </Text>
                <Text padding="2px 3px">Cuenta En Bs.: {accountNumber}</Text>
                <Text padding="2px 3px">JAVEST S.R.L</Text>
              </View>
              <View width="50%" flexDirection="column">
                <Text padding="2px 3px">
                  Elaborado por: {user.user.name} {user.user.fatherLastName}{" "}
                  {user.user.motherLastName}
                </Text>
                <Text padding="2px 3px">NIT: 516076028</Text>
                {/* <Text padding="2px 3px">SWIFT: BAUNBO22</Text> */}
              </View>
            </View>
            {
              isQuotation &&
              <Text padding="2px 3px" fontSize="7px">
                Nota.: La presente Proforma esta sujeta a Cambio dentro del plazo
                requerido por Javest SRL por variacion en el T./C.
              </Text>
            }
          </View>
          <View
            flexDirection="column"
            padding="4px 0"
            justifyContent="center"
            alignItems="center"
            style={{ backgroundColor: "#213a8f" }}
          >
            <Text padding="2px 3px" color="white">
              Dirección Montecinos esquina Velazco Galvarro, Nro 991 edificio S/N primer piso oficina 10, Oruro, Bolivia
            </Text>
            <Text padding="2px 3px" color="white">
              Teléfono: (591)76426163 Teléfono: 2119416
            </Text>
          </View>
        </View>
      </Page>
    </Document>
  );

  return (
    <div>
      {
        !isQuotation &&
        <div className="flex justify-end mb-2">
          <Button className="py-2" onClick={handleOnClick}>
            Guardar planilla <i className="fas fa-cloud-upload-alt"></i>
          </Button>
        </div>
      }
      <PDFViewer
        style={{
          width: 900,
          height: window.innerHeight - 100,
        }}
        children={MyDoc}
      />
    </div>
  );
};

export default RenderSettlement;